<!-- ===============================
     CERTIFICATES & REPORTS
     =============================== -->

<section class="mb-4">

  <!-- HEADER -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div>
      <p class="text-muted text-xs mb-0">
        Year-on-year BEE documentation and assessments
      </p>
    </div>

    <span class="badge bg-warning text-white text-xs rounded-3 px-3 py-2">
      {{ total_documents }} Total Documents
    </span>
  </div>

  <!-- ===============================
       SUMMARY CARDS
       =============================== -->
  <div class="row g-3">

    <!-- BEE CERTIFICATES -->
    <div class="col-12 col-md-6 col-xl-3">
      <div
        class="card shadow-sm rounded-4 h-100 cursor-pointer border-primary"
        @click="set_active_tab('bee_certificates')"
      >
        <div class="card-body d-flex align-items-center gap-3">
          <button class="btn btn-primary rounded-4" disabled>
            <i class="bi bi-award-fill fs-5"></i>
          </button>

          <div>
            <h5 class="mb-0 fw-bold">
              {{ certificates_reports.bee_certificates.count }}
            </h5>
            <p class="text-xs text-muted mb-0">
              {{ certificates_reports.bee_certificates.label }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- INTERNAL ASSESSMENTS -->
    <div class="col-12 col-md-6 col-xl-3">
      <div
        class="card shadow-sm rounded-4 h-100 cursor-pointer border-primary"
        @click="set_active_tab('internal_assessments')"
      >
        <div class="card-body d-flex align-items-center gap-3">
          <button class="btn btn-primary rounded-4" disabled>
            <i class="bi bi-clipboard-check-fill fs-5"></i>
          </button>

          <div>
            <h5 class="mb-0 fw-bold">
              {{ certificates_reports.internal_assessments.count }}
            </h5>
            <p class="text-xs text-muted mb-0">
              {{ certificates_reports.internal_assessments.label }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- ADVISORY OPINIONS -->
    <div class="col-12 col-md-6 col-xl-3">
      <div
        class="card shadow-sm rounded-4 h-100 cursor-pointer border-primary"
        @click="set_active_tab('advisory_opinions')"
      >
        <div class="card-body d-flex align-items-center gap-3">
          <button class="btn btn-secondary rounded-4" disabled>
            <i class="bi bi-chat-left-text-fill fs-5"></i>
          </button>

          <div>
            <h5 class="mb-0 fw-bold">
              {{ certificates_reports.advisory_opinions.count }}
            </h5>
            <p class="text-xs text-muted mb-0">
              {{ certificates_reports.advisory_opinions.label }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- CSD DOCUMENTS -->
    <div class="col-12 col-md-6 col-xl-3">
      <div
        class="card shadow-sm rounded-4 h-100 cursor-pointer border-primary"
        @click="set_active_tab('csd_documents')"
      >
        <div class="card-body d-flex align-items-center gap-3">
          <button class="btn btn-warning text-dark rounded-4" disabled>
            <i class="bi bi-file-earmark-text-fill fs-5"></i>
          </button>

          <div>
            <h5 class="mb-0 fw-bold">
              {{ certificates_reports.csd_documents.count }}
            </h5>
            <p class="text-xs text-muted mb-0">
              {{ certificates_reports.csd_documents.label }}
            </p>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>

<!-- ===============================
     TABS (INLINE, NO COMPONENT)
     =============================== -->
  <div class="bee-tabs mb-4">
    <div class="d-flex gap-2 flex-wrap">

      <button
        v-for="tab in tabs"
        :key="tab.key"
        type="button"
        class="btn btn-sm rounded-3 text-xs d-flex align-items-center gap-1"
        :class="active_tab === tab.key
          ? 'btn-primary'
          : 'btn-outline-secondary'"
        @click="set_active_tab(tab.key)"
      >
        <i :class="['bi', tab.icon]"></i>
        <span>{{ tab.label }}</span>
      </button>

    </div>
  </div>

<!-- ===============================
     DETAIL PANEL
     =============================== -->
<div
  v-if="active_tab"
  class="card shadow-sm rounded-4 p-4 border-primary"
>

  <!-- HEADER -->
  <div class="d-flex align-items-start gap-3 mb-4">
    <div
      class="btn rounded-4 d-flex align-items-center justify-content-center"
      :class="{
        'btn-primary': active_tab === 'bee_certificates',
        'btn-primary': active_tab === 'internal_assessments',
        'btn-secondary': active_tab === 'advisory_opinions',
        'btn-warning text-dark': active_tab === 'csd_documents'
      }"
      disabled
    >
      <i :class="['bi', current_tab.icon, 'fs-5']"></i>
    </div>

    <div>
      <h5 class="fw-bold mb-1 text-xs">{{ current_tab.label }}</h5>
      <p class="text-xs text-muted mb-0">
        {{ current_tab.description }}
      </p>
    </div>
  </div>

  <!-- YEAR ROW -->
  <div class="d-flex justify-content-between align-items-center mb-5">
    <div class="d-flex align-items-center gap-3">
      <i class="bi bi-folder"></i>
      <span class="fw-semibold text-xs">FY 2026</span>
      <span class="badge bg-warning text-white text-xs">
        {{ current_tab.count }} files
      </span>
      <i class="bi bi-chevron-down text-muted"></i>
    </div>

    <button class="btn btn-outline-secondary rounded-3 text-xs btn-sm">
      <i class="bi bi-upload me-2"></i>
      Upload
    </button>
  </div>

  <!-- EMPTY STATE -->
  <div class="text-center text-xs text-muted py-5">
    <i class="bi bi-file-earmark fs-1 d-block mb-3"></i>
    <p class="mb-0">No documents uploaded yet</p>
  </div>

</div>
